import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import { AppDispatch, RootState } from "../../store";
import { refreshAccessToken, setSessionLoading, syncSessionFromApi } from "../../slices/session";
import { FullPageLoading } from "../utils/Loading";

function isPublicAuthBootstrapPath(pathname: string) {
  return (
    pathname.startsWith("/authentication/") ||
    pathname.startsWith("/auth/microsoft/")
  );
}

function PersistLogin() {
  const loading = useSelector((state: RootState) => state.session.loading);
  const accessToken = useSelector(
    (state: RootState) => state.session.accessToken
  );
  const refreshToken = useSelector(
    (state: RootState) => state.session.refreshToken
  );
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      try {
        if (!accessToken && isPublicAuthBootstrapPath(location.pathname)) {
          dispatch(setSessionLoading(false));
          return;
        }

        if (accessToken) {
          const r = await dispatch(syncSessionFromApi());
          if (cancelled) return;
          if (syncSessionFromApi.rejected.match(r) && refreshToken) {
            await dispatch(refreshAccessToken(refreshToken));
          }
        } else if (refreshToken) {
          await dispatch(refreshAccessToken(refreshToken));
        } else {
          dispatch(setSessionLoading(false));
        }
      } catch (error) {
        console.error(error);
        dispatch(setSessionLoading(false));
      }
    };

    void run();
    return () => {
      cancelled = true;
    };
  }, [accessToken, refreshToken, dispatch]);

  return <>{loading ? <FullPageLoading /> : <Outlet />}</>;
}

export default PersistLogin;
